// @flow

import { get } from '@zapier/common-utils';

import type { Keys } from '@zapier/common-utils/src/types';

const exists = (thing: any, ...rest: Keys[]) => {
  if (rest.length > 0) {
    thing = get(thing, ...rest);
    return exists(thing);
  }

  return typeof thing !== 'undefined' && thing !== null;
};

export default exists;
